<template>
	<div>
		<bsh-datatable 
			:columns="columns"
            :buttons="buttons" 
			:link="$url+'/api/adm/despesas/datatable/'+date"
            actionFild
            @show="show"
			sorting>
		</bsh-datatable>
	</div>
</template>

<script>
export default {
    props: ['date'],
	data(){
		return {
            columns: [
                {
                    label: '#',
                    field: 'id',
                    order: 'despesas.id',
                    sort: 'asc'
                },
                {
                    label: 'Nome',
                    field: 'nome',
                    order: 'despesas.nome',
                    sort: 'asc'
                },
                {
                    label: 'Categoria',
                    field: 'categoria.nome',
                    order: 'categ_despesas.nome',
                    sort: 'asc'
                },
                {
                    label: 'Quantidade',
                    field: 'quantidade_medida',
                    order: 'despesas.quantidade',
                    sort: 'asc'
                },
                {
                    label: 'Data',
                    field: 'data_br',
                    order: 'despesas.data',
                    sort: 'asc'
                },
                {
                    label: 'Valor',
                    field: 'valor_br',
                    order: 'despesas.valor',
                    sort: 'asc'
                },
            ],
            buttons: [
                {
                    action: 'show',
                    classe: 'btn btn-primary',
                    iconClass: 'fas fa-eye'
                }
            ]
    	}
	},
    methods: {
        show(dado){
            this.$emit('show', dado.id);
        }
    }
}
</script>